import { STUDY_LANDSCAPES } from "@/features/story/data/landscapes";

/**
 * Resolve a human territory name for a published insight.
 * Prefers tokens in `algorithmOrQuery`, then a "Territoire :" label prefix.
 */
export function territoryLabelFromInsight(
  label: string,
  algorithmOrQuery?: string | null,
  fallback?: string | null,
): string {
  const hay = `${algorithmOrQuery ?? ""} ${label}`.toLowerCase();

  for (const place of STUDY_LANDSCAPES) {
    const slug = place.id.replace(/-/g, "[-–—\\s]*");
    const short = place.shortLabel.toLowerCase().replace(/[–—]/g, "[-–—\\s]*");
    const re = new RegExp(`(?:^|[^a-z])(?:${slug}|${short})(?:$|[^a-z])`, "i");
    if (re.test(hay)) return place.shortLabel;
  }

  const prefix = label.match(/^([^:]+)\s*:/);
  if (prefix?.[1]?.trim()) {
    const candidate = prefix[1].trim();
    const known = STUDY_LANDSCAPES.find(
      (p) =>
        p.shortLabel.toLowerCase() === candidate.toLowerCase() ||
        p.label.toLowerCase() === candidate.toLowerCase(),
    );
    if (known) return known.shortLabel;
    return candidate;
  }

  return fallback?.trim() || "—";
}

/** Drop a leading "Territoire :" prefix when the territory is shown separately. */
export function insightLabelWithoutTerritory(label: string, territory: string): string {
  const escaped = territory.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  return label.replace(new RegExp(`^\\s*${escaped}\\s*:\\s*`, "i"), "").trim() || label;
}
